// File: src/components/layouts/helpers/Sticky/Sticky.tsx
// Purpose: Layout or container component

import React from "react";
import styled from "styled-components";

interface StickyProps {
  children: React.ReactNode;
  top?: string;
  bottom?: string;
  zIndex?: number;
  responsive?: boolean;
}

const StyledSticky = styled.div<StickyProps>`
  position: sticky;
  top: ${({ top }) => top || "auto"};
  bottom: ${({ bottom }) => bottom || "auto"};
  z-index: ${({ zIndex }) => zIndex || 1000};
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.elevations.low};
  padding: ${({ theme }) => theme.spacing.md};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  ${({ responsive, theme }) =>
    responsive &&
    `
    @media (max-width: ${theme.breakpoints.mobile}) {
      padding: ${theme.spacing.sm};
      font-size: ${theme.typography.caption.fontSize};
    }
  `}
`;

export const Sticky: React.FC<StickyProps> = ({
  children,
  top,
  bottom,
  zIndex = 1000,
  responsive = true,
}) => {
  return (
    <StyledSticky top={top} bottom={bottom} zIndex={zIndex} responsive={responsive}>
      {children}
    </StyledSticky>
  );
};